import { CohortEnumSchema } from '@eigtech/auth0-types';
import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const GetUploadScreenshotUrlApiSchema = {
    params: z.object({
        cohort: CohortEnumSchema,
        meetingId: z.string(),
        entityId: CornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    query: z.object({
        startTime: z.string().datetime().optional(),
    }),
    response: z.object({
        fields: z.record(z.string(), z.string()),
        url: z.string(),
    }),
};
export const GetUploadScreenshotUrlRequestSchema = GetUploadScreenshotUrlApiSchema.params
    .merge(GetUploadScreenshotUrlApiSchema.query)
    .merge(GetUploadScreenshotUrlApiSchema.headers);
